module.exports = __webpack_public_path__ + "img/retailer_nav_gray.2ba3b453.svg";